import React from "react";
import withDataTable from "./withDataTable";
import { 
   getSelfEvaluations, 
   deletePDDById 
} from "services/pdd";
import { Util } from "common/util";
import { t } from "i18next";
import moment from "moment";
import {
   Rejected,
   Approved, 
   Pending, 
   Submitted, 
   RequiredUpdate 
} from "common/status";
import Enum from "common/enums";

const pathName = "/performance/pdd";
const columns = [
   {
      title: t("text_code"),
      dataIndex: "employeeCode",
      key: "employeeCode",
      width: 120
    },
   {
      title: t("text_employee_name"),
      dataIndex: "employeeName",
      key: "index"
   },
   {
      title: "Year",
      dataIndex: "year",
      key: "year"
   },
   {
      title: "Approval By",
      dataIndex: "approver",
      key: "approver"
   },
   {
      title: "Approved Date",
      dataIndex: "approvedDate",
      key: "approvedDate",
      render: approvedDate => moment(approvedDate).format("DD/MM/YYYY")
   },
   {
      title: t("text_status"),
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (status) => {
         if (Enum.OBJECTIVES_SETTING.PENDING === status) {
            return <Pending />
         } else if (Enum.OBJECTIVES_SETTING.APPROVED === status) {
            return <Approved />
         } else if (Enum.OBJECTIVES_SETTING.REQUIRED_UPDATE === status) {
            return <RequiredUpdate />
         } else if (Enum.OBJECTIVES_SETTING.REJECTED === status) {
            return <Rejected />
         } else {
            return <Submitted />
         }
      }
   }
];

const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 20;

if (current) {
   defaultCurrent = current;
}

if (size) {
   defaultPageSize = size;
}

const getData = () => {
   const option = {};
   const params = new URLSearchParams(document.location.search);
   const search = params.get("search");
   const year = params.get("year");
   
   if (search) {
      option["search"] = search;
   }

   if (year) {
      option["year"] = year;
   }

   return getSelfEvaluations(option);
};

const handleSearch = (e) => {
   const queryParams = new URLSearchParams(document.location.search);
   const value = e.target.value;

   if (value) {
      queryParams.set("search", value);
   } else {
      queryParams.delete("search");
   }

   (new Util()).pushParamsToURL(pathName, queryParams.toString());
}

export default withDataTable({
   title: "Objective Settings",
   addNewLink: "/performance/pdd/create?type=object-setting",
   updateLink: "/performance/pdd/update",
   topFilterItems: [],
   showFilter: false,
   showPagination: true,
   showAddNew: true,
   showButtonInfo: false,
   showButtonSearch: false,
   columns,
   pathName,
   defaultCurrent,
   defaultPageSize,
   getData,
   handleSearch,
   permission: "evaluation",
   confirmSoftDelete: (id) => deletePDDById(id),
});
